import React from "react"

const Subtitle = ({ attributes, subtitle }) => {
  return (
    <div
      {...attributes}
      style={{
        color: "white",
        fontSize: "11px",
        paddingBottom: "0px",
        fontFamily: "system-ui",
        margin: 0
      }}
    >
      {subtitle}
    </div>
  )
}

export default Subtitle
